import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { noop } from "lodash";
import * as React from "react";

import { DesignToken, RadiusToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon/Icon";
import { withVar } from "themes/helpers";

const StyledContainer = styled.div`
  position: relative;
  text-align: right;
`;

const StyledInput = styled.input`
  display: inline-block;
  width: 100%;
  height: 40px;
  padding: 0 36px 0 17px;

  font-size: 14px;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  text-align: left;
  border-radius: var(${RadiusToken.Radius3});
  border: solid 1px ${withVar(DesignToken.BorderBasicPrimary)};
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};

  box-sizing: border-box;

  visibility: hidden;
  opacity: 0;
  width: 0;
  transition:
    all 0.2s ease-in-out,
    visibility 0s linear 0.25s;

  &:focus,
  &:active {
    outline: none;
    background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
    border-color: ${withVar(DesignToken.ActionPrimaryDefault)};
  }

  @media (max-width: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.mobileBreakpoint
    }) {
    width: 100%;
  }
`;

const inputFadeIn = css`
  visibility: visible;
  opacity: 1;
  width: 300px;
  transition-delay: 0s;
`;

const StyledButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  height: 40px;
  padding: 0 13px;
  border: none;
  background: none;
  cursor: pointer;
`;

interface IProps {
  value: string;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange(nextValue: string): any;
  placeholder?: string;
  forceOpen?: boolean;
}

interface IState {
  value: string;
  showInput: boolean;
}

/**
 * Search Input
 *
 * @example
 *   <SearchBar value={curValue} onChange={newValue => ...} />
 */
export class SearchBar extends React.Component<IProps, IState> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(props: any) {
    super(props);

    this.state = {
      value: props.value,
      showInput: false,
    };
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setValue(value: string, cb = noop) {
    this.setState({ value }, () => {
      cb();
      this.props.onChange(this.state.value);
    });
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  setInputRef = (ref: any) => {
    this.inputRef = ref;
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  handleChange = (event: any) => {
    this.setValue(event.target.value);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleClear = () => {
    if (this.state.value) {
      this.setValue("", () => this.inputRef.focus());
    } else {
      this.setState({ showInput: false });
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleBlur = () => {
    if (!this.state.value) {
      this.setState({ showInput: false });
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleShowSearch = () => {
    this.setState({ showInput: true }, () => this.inputRef.focus());
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    this.inputRef.blur();
  };

  // @ts-expect-error TS(2564): Property 'inputRef' has no initializer and is not ... Remove this comment to see the full error message
  inputRef: HTMLInputElement;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const showInput = this.props.forceOpen || this.state.showInput;

    return (
      <StyledContainer>
        <form onSubmit={this.handleSubmit}>
          <StyledInput
            css={showInput && inputFadeIn}
            ref={this.setInputRef}
            value={this.state.value}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            placeholder={this.props.placeholder}
          />
        </form>

        {showInput && (
          <StyledButton onClick={this.handleClear} title={this.state.value ? "Clear" : "Close"}>
            <Icon name={IconsEnum.Close} fill={withVar(DesignToken.ActionPrimaryDefault)} width="12px" height="12px" />
          </StyledButton>
        )}

        {!showInput && (
          <StyledButton onClick={this.handleShowSearch} title="Search">
            <Icon name={IconsEnum.Search} fill={withVar(DesignToken.ActionPrimaryDefault)} width="15px" height="15px" />
          </StyledButton>
        )}
      </StyledContainer>
    );
  }
}
